import { CartUpdateEvent, CartErrorEvent } from '@theme/events';
import { fetchCartChange, refreshCartSurfaces } from '@theme/cart-refresh';

let abortController = null;

function findLineInput(surface, lineKey) {
  const inputs = surface.querySelectorAll('.cart-qty-input, .site-header__cart-drawer-qty-input');
  for (const input of inputs) {
    if (input.dataset.lineKey === lineKey) return input;
  }
  return null;
}

function findLineItem(surface, lineKey) {
  return surface.querySelector(`[data-line-key="${lineKey}"]`);
}

function optimisticallyRemove(item) {
  const height = item.offsetHeight;
  item.style.maxHeight = height + 'px';
  item.style.overflow = 'hidden';
  item.style.transition =
    'opacity 150ms ease, max-height 300ms ease, margin 300ms ease, padding 300ms ease';
  item.style.opacity = '0';
  item.style.pointerEvents = 'none';

  /* Force reflow so the browser registers the starting max-height */
  item.offsetHeight;

  item.style.maxHeight = '0';
  item.style.marginTop = '0';
  item.style.marginBottom = '0';
  item.style.paddingTop = '0';
  item.style.paddingBottom = '0';
}

async function updateLineQuantity(lineKey, quantity, optimisticInput) {
  if (abortController) abortController.abort();
  const ctrl = new AbortController();
  abortController = ctrl;
  const signal = ctrl.signal;

  if (optimisticInput) {
    optimisticInput.value = String(quantity);
    optimisticInput.dataset.userEdited = '';
  }

  try {
    const response = await fetchCartChange(lineKey, quantity, signal);

    /* Dispatch cart:update with sections data.
       cart-items-component self-morphs from event.detail.data.sections.
       cart-icon.js updates the badge from event.detail.data.itemCount. */
    document.dispatchEvent(
      new CartUpdateEvent(response, null, {
        source: 'cart-actions',
        itemCount: response.item_count,
        sections: response.sections || null,
      })
    );

    if (optimisticInput) delete optimisticInput.dataset.userEdited;
  } catch (err) {
    if (err.name === 'AbortError') return;
    console.error('[cart-actions]', err);
    document.dispatchEvent(
      new CartErrorEvent(null, '')
    );
    /* Fallback: fetch and morph fresh cart surfaces */
    try {
      await refreshCartSurfaces(signal);
    } catch {}
    if (optimisticInput) delete optimisticInput.dataset.userEdited;
  }
}

document.addEventListener('click', (event) => {
  const CART_DRAWER_SELECTOR = '[data-cart-drawer]';
  const CART_PAGE_SELECTOR = '[data-cart-page]';

  const drawer = event.target.closest(CART_DRAWER_SELECTOR);
  const cartPage = event.target.closest(CART_PAGE_SELECTOR);
  if (!drawer && !cartPage) return;

  const action = event.target.closest('[data-action]');
  if (!action) return;

  event.preventDefault();
  const lineKey = action.dataset.lineKey;
  if (!lineKey) return;

  const surface = drawer || cartPage;
  const input = findLineInput(surface, lineKey);

  if (action.dataset.action === 'remove') {
    const lineItem = findLineItem(surface, lineKey);
    if (lineItem) optimisticallyRemove(lineItem);
    updateLineQuantity(lineKey, 0, null);
    return;
  }

  if (action.dataset.action === 'increase' || action.dataset.action === 'decrease') {
    if (!input) return;
    const current = parseInt(input.value, 10) || 0;
    const delta = action.dataset.action === 'increase' ? 1 : -1;
    const next = Math.max(0, current + delta);
    updateLineQuantity(lineKey, next, input);
  }
});
